import { defineStore } from 'pinia'
import { ref } from 'vue'

interface ConversationData {
  conversationId: string
  messages: any[]
  classroomId: string
  workspaceId: string
  timestamp: number
}

export const useConversationStore = defineStore('conversation', () => {
  const currentConversation = ref<ConversationData | null>(null)
  const isLoading = ref(false)

  const setConversation = (data: ConversationData) => {
    currentConversation.value = data
  }

  const updateMessages = (messages: any[]) => {
    if (currentConversation.value)
      currentConversation.value.messages = messages
  }

  const updateConversationId = (conversationId: string) => {
    if (currentConversation.value)
      currentConversation.value.conversationId = conversationId
  }

  const clearConversation = () => {
    currentConversation.value = null
  }

  const getConversationForClassroom = (classroomId: string, workspaceId: string) => {
    if (currentConversation.value
        && currentConversation.value.classroomId === classroomId
        && currentConversation.value.workspaceId === workspaceId)
      return currentConversation.value

    return null
  }

  return {
    currentConversation,
    isLoading,
    setConversation,
    updateMessages,
    updateConversationId,
    clearConversation,
    getConversationForClassroom,
  }
})
